import React, { useEffect, useRef, useState, useCallback } from "react";
import "./ManualCallModal.scss";
import { Flex, Modal } from "antd";
import { ReactComponent as CollectEaze } from "../../../assets/Icons/CollectEaze.svg";
import { ReactComponent as Customer } from "../../../assets/Icons/Customer.svg";
import GreenSmile from "../../../assets/Icons/GreenSmile.svg";
import GaugeChart from "../../../Reuseable/GaugeChart/GaugeChart";
import AudioPlayer from "../../../Reuseable/AudioPlayer/AudioPlayer";
import moment from "moment";

const ManualCallModal = ({ open, onClose, callData }) => {
  const scrollRef = useRef(null);
  const [scrollClass, setScrollClass] = useState("");

  const conversation = [
    {
      sender: "Tele Caller",
      time: "01:00pm.",
      message:
        "Good afternoon, sir. This is Arlene McCoy calling from Agent Company regarding your HDFC personal loan ending with 9012. Am I speaking with Mr. Guy Hawkins?",
      icon: <CollectEaze />,
    },
    {
      sender: "Customer",
      time: "01:32pm.",
      message: "Yes, speaking.",
      icon: <Customer />,
    },
    {
      sender: "Tele Caller",
      time: "01:32pm.",
      message:
        "Thank you, sir. I'm calling to confirm the final settlement terms that have been approved for your loan account. As discussed earlier, the current outstanding is ₹2,79,157. You’ve been offered a one-time settlement of ₹1,90,000, valid till June 30th.",
      icon: <CollectEaze />,
    },
    {
      sender: "Customer",
      time: "01:33pm.",
      message: "Hmm okay. That’s the same amount mentioned before, right?",
      icon: <Customer />,
    },
    {
      sender: "Tele Caller",
      time: "01:34pm.",
      message:
        "Yes, sir. This is the final and revised amount. Once paid, your loan will be closed and marked as “settled” with the credit bureau. Would you be comfortable proceeding with this?",
      icon: <CollectEaze />,
    },
    {
      sender: "Customer",
      time: "01:33pm.",
      message: "Hmm okay. That’s the same amount mentioned before, right?",
      icon: <Customer />,
    },
    {
      sender: "Tele Caller",
      time: "01:34pm.",
      message:
        "Yes, sir. This is the final and revised amount. Once paid, your loan will be closed and marked as “settled” with the credit bureau. Would you be comfortable proceeding with this?",
      icon: <CollectEaze />,
    },
  ];


  const updateBlur = useCallback(() => {
    const container = scrollRef.current;
    if (!container) return;

    const { scrollTop, scrollHeight, clientHeight } = container;

    if (scrollHeight <= clientHeight + 1) {
      setScrollClass(""); // No scroll
    } else if (scrollTop <= 0) {
      setScrollClass("scroll-bottom"); // Only bottom blur
    } else if (scrollTop + clientHeight >= scrollHeight - 1) {
      setScrollClass("scroll-top"); // Only top blur
    } else {
      setScrollClass("scroll-middle"); // Both top and bottom
    }
  }, []);

  useEffect(() => {
    const container = scrollRef.current;
    if (!open || !container) return;

    updateBlur(); // Initial call
    container.addEventListener("scroll", updateBlur);

    return () => {
      container.removeEventListener("scroll", updateBlur);
    };
  }, [open, updateBlur]);

  

  return (
    <div className="modal-main">
      <Modal
        open={open}
        onCancel={onClose}
        footer={
          <Flex className="manual-call-footer">
            <Flex className="footer">
              <p>Sentiment</p>
              <button>
                <img src={GreenSmile} alt="GreenSmile" />
                Positive
              </button>
            </Flex>
            <Flex className="footer">
              <p>
                Predicted <br /> Disposition
              </p>
              <Flex className="data-and-graph">
                <Flex className="data">
                  <p className="data-head">PTP</p>
                  <h1>88%</h1>
                </Flex>
                <GaugeChart percent={0.88} />
              </Flex>
            </Flex>
          </Flex>
        }
        title={
          <div className="modal-header">
            Manual Call Transcript <span>{moment(callData?.start_stamp).format("MMM D, YYYY – hh:mm A")}</span>
          </div>
        }
        width={581}
        className={`ManualCallModal ${scrollClass}`}
      >
        <div className="blurTop" />
        <div className="blurBottom" />

        <div className="modalScrollWrapper" ref={scrollRef}>
          <div className="conversation-timeline">
            {conversation.map((item, index) => (
              <div className="timeline-item" key={index}>
                <div className="timeline-icon">
                  {typeof item.icon === "string" ? (
                    <div className="circle-icon">{item.icon}</div>
                  ) : (
                    item.icon
                  )}
                </div>
                <div className="timeline-content">
                  <div className="sender-time">
                    <span className="sender">{item.sender}</span>
                    <span className="time">{item.time}</span>
                  </div>
                  <div className="message">{item.message}</div>
                </div>
              </div>
            ))}
          </div>
          <div className="manual-player"></div>
        </div>
        <div className="manual-player">
          <AudioPlayer
            src={callData?.recording_file}
            rewindSeconds={5}
            forwardSeconds={5}
            width="100%"
          />
        </div>
      </Modal>
    </div>
  );
};

export default ManualCallModal;
